import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import GoogleMapReact from 'google-map-react'
import Supercluster from 'supercluster'
import queryString from 'querystring-es3'
import CourseMarker from '../country/CourseMarker'
import ClusterMarker from '../country/ClusterMarker'
import Popup from '../country/Popup'
import { getZoom } from '../../js/mapHelpers'

const Marker = ({ children }) => children

const getCenter = (location, center) => {
  const search = queryString.parse(location.search)
  if (search.center) {
    const latLng = search.center.split(',')
    return {
      lat: parseFloat(latLng[0]),
      lng: parseFloat(latLng[1]),
    }
  }

  if (center) {
    return center
  }

  return {
    lat: 0,
    lng: 0,
  }
}

function GamesMap(props) {
  const location = useLocation()
  const navigate = useNavigate()
  const propsZoom = props.zoom || 5.5

  const [courses, setCourses] = useState([])
  const [points, setPoints] = useState([])
  const [zoom, setZoom] = useState(propsZoom)
  const [bounds, setBounds] = useState(null)
  const [supercluster, setSupercluster] = useState(null)
  const [popup, setPopup] = useState(null)
  const [defaultZoom] = useState(getZoom(location, propsZoom))
  const [defaultCenter] = useState(getCenter(location, props.center))

  const mapRef = React.createRef()

  useEffect(() => {
    console.log('createSuperclusterState', props.courses)
    const _points = props.courses.map((course) => ({
      type: 'Feature',
      properties: { cluster: false, id: course.groupId, category: course.name },
      geometry: {
        type: 'Point',
        coordinates: [
          course.location.longitude * 0.000001,
          course.location.latitude * 0.000001,
        ],
      },
    }))

    const _supercluster = new Supercluster({
      radius: 40,
      maxZoom: 20,
    })

    _supercluster.load(_points)
    setCourses(props.courses)
    setPoints(_points)
    setSupercluster(_supercluster)
  }, [props.courses])

  const onCourseGroupClicked = (cluster) => {
    const { id } = cluster.properties
    props.onCourseGroupClicked(courses.find((course) => course.groupId === id))
  }

  const onClusterClicked = (cluster) => {
    const children = supercluster.getChildren(cluster.id)
    console.log('Click onClusterClicked', cluster, children)
    setPopup({
      cluster,
      children,
    })
  }

  const renderMarkers = () => {
    console.log('renderMarkers')
    if (!supercluster || !bounds || bounds.length === 0) return null

    try {
      const clusters = supercluster.getClusters(bounds, zoom)
      return clusters.map((cluster) => {
        const [longitude, latitude] = cluster.geometry.coordinates
        const { cluster: isCluster, point_count: pointCount } =
          cluster.properties

        if (isCluster) {
          return (
            <Marker
              key={`cluster-${cluster.id}`}
              lat={latitude}
              lng={longitude}
            >
              <ClusterMarker
                cluster={cluster}
                supercluster={supercluster}
                mapRef={mapRef}
                pointCount={pointCount}
                pointsLength={points.length}
                onClickCluster={(cluster) => onClusterClicked(cluster)}
              />
            </Marker>
          )
        }

        return (
          <Marker
            key={`course-${cluster.properties.id}`}
            lat={latitude}
            lng={longitude}
          >
            <CourseMarker
              cluster={cluster}
              onClick={() => onCourseGroupClicked(cluster)}
            />
          </Marker>
        )
      })
    } catch (e) {
      return null
    }
  }

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: '50vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_MAPS_KEY }}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        center={getCenter(location, props.center)}
        zoom={getZoom(location, propsZoom)}
        yesIWantToUseGoogleMapApiInternals={true}
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map
        }}
        onChange={({ center, zoom, bounds }) => {
          console.log('onChange', center, zoom, bounds)
          const currentSearch = location.search
          const newSearch = `?zoom=${zoom}&center=${center.lat},${center.lng}`
          if (newSearch !== currentSearch) {
            navigate(location.pathname + newSearch)
          }
          setZoom(zoom)
          setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat,
          ])
        }}
        options={{
          mapTypeControl: true,
        }}
      >
        {renderMarkers()}
        {popup && (
          <Marker
            key="popup"
            lat={popup.cluster.geometry.coordinates[1]}
            lng={popup.cluster.geometry.coordinates[0]}
          >
            <Popup
              clusters={popup.children}
              onClickCourse={onCourseGroupClicked}
            />
          </Marker>
        )}
      </GoogleMapReact>
    </div>
  )
}

export default GamesMap
